import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { useId } from 'react';
import * as styles from './ai-gradient-sparkle-icon.css';
import { SPARKLE_FILLED_PATH } from './sparkle-path';

/** AI brand gradient (same stops as assistant footer "Ask Agent" sparkle). */

type AiGradientSparkleIconProps = { size?: number };

export function AiGradientSparkleIcon({ size = 40 }: AiGradientSparkleIconProps) {
  const reactId = useId();
  const gradientId = `ai-gradient-sparkle-${reactId.replace(/:/g, '')}`;

  return (
    <svg
      className={styles.svgRoot}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" style={{ stopColor: themeVars.palette['orange-500'] }} />
          <stop offset="100%" style={{ stopColor: themeVars.palette['violet-600'] }} />
        </linearGradient>
      </defs>
      <path d={SPARKLE_FILLED_PATH} fill={`url(#${gradientId})`} />
    </svg>
  );
}
